<ng-container *transloco="let t; prefix: 'nc-pagination'">
  @if (!hideLabels()) {
    <div class="left" data-cy="pagination-status">
      @if (!useCustomViewingFromTo) {
        <p>
          {{ pageMeta.total_count > 0 ? t('viewing_from_to', viewingFromTo) : t('no_results') }}
        </p>
      } @else {
        <ng-content select="[viewingFromTo]"></ng-content>
      }
    </div>
  }

  <div class="right">
    @if (!hideLabels()) {
      @if (!useCustomPageFromTo) {
        <p>{{ pageMeta.total_count > 0 ? t('page_from_to', pageFromTo) : '' }}</p>
      } @else {
        <ng-content select="[pageFromTo]"></ng-content>
      }

      <ng-template #customPageFromTo>
        <ng-content select="[pageFromTo]"></ng-content>
      </ng-template>
    }

    <div class="actions">
      <button
        accredible-button-icon
        data-cy="btn-previous-page"
        [attr.aria-label]="t('aria_prev')"
        [size]="'small'"
        [color]="'natural'"
        [icon]="'chevron-left'"
        [iconSize]="'8px'"
        [disabled]="!pageMeta.prev_page"
        (click)="pageChange.emit(pageMeta.prev_page)"></button>

      <button
        accredible-button-icon
        data-cy="btn-next-page"
        [attr.aria-label]="t('aria_next')"
        [size]="'small'"
        [color]="'natural'"
        [icon]="'chevron-right'"
        [iconSize]="'8px'"
        [disabled]="!pageMeta.next_page"
        (click)="pageChange.emit(pageMeta.next_page)"></button>
    </div>
  </div>
</ng-container>
